const subscription = {
  subscribe: "M'abonner",
  demoState: "Démo",
  ongoingState: "Abonné",
  expiryState: "Expiré",
  resubscribe: "Me réabonner",
  extendSubscribe: "Prolonger mon abonnement jusqu'au : ",
  status: "Statut :",
  endsubscription: "Fin de l'abonnement :",
  expiryDate: "Date d'expiration :",
  subscribeTitle: "Contenu de l'offre",
  subscribeContent:
    "Cette offre comporte un accès illimité à tous les exercices et fiches disponibles pour les niveaux A1, A2, B1 et B2 pour une durée de 1 an.",
  subscribePrice: "Le montant de l’abonnement est de",
  expiryDateReminder: "Votre abonnement prendra fin le",
  renewalProposal:
    "Pour pouvoir continuer à profiter d'iizenglish, prolongez votre abonnement !",
  renewalOk: "Ok",
  renewalDisable: "Ne plus afficher",
  renewalAccept: "Me réabonner",
  resubscribeExtendDate: "Prolongera mon abonnement jusqu'au : ",
  remiderSubscriptionModalTitle: "Abonnez-vous !",
  mySubscription: "Mon abonnement",
  subscription: "Abonnement",
};

export default subscription;
